"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7841],{

/***/ 50863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CardSelections; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/inhouse.png
/* harmony default export */ var inhouse = ({"src":"/_next/static/media/inhouse.7d030294.png","height":831,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAY1BMVEVzYFFiUTtKRTy8ilanimmXoZdxgoNkWkxKSD+NcU6cfWB6b2dsamBrZlWIg3JPXFtARkRZXFZhc3ZWSDZGOy1tWD+jlIZ9d2NQRzyCemuObUfZp3d2g4KFnKDBn3mxpZE9Myb9v98iAAAAGHRSTlP9ulT8/f61/nq5x/qzwPqzv/y1xbj8+njlYmiOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nAXBBwKAIAwEsAOBFhwMFYv7/68kQfBeqW3VuIZT/t0wXgNQ/Q7QQpCxMZq1z52FMU/OlZh0B0RrApNlFKEdAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/kantine.png
/* harmony default export */ var kantine = ({"src":"/_next/static/media/kantine.821eb761.png","height":554,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAV1BMVEXM093DwMLs2dKPkJKpq6rs6ezDr5TLy9Hj3NHh2ty6t7mpu9GusbjBizXWx7ekkmWsdFfK0tqMlI7Pnoq1nonjy6TO1tXLxZHk1sX21NXs07K5mXP86NU/K/vNAAAAFHRSTlO5u/5Uev37uP3+s8W1/f39/cR4+mII/0QAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA5SURBVHicBcEHAoAgDACxAwptXThw+/93mtArwJI4fL+e+AmtjHXe3hWzyTxn4Swt3tmF0A1BVdMPOR4CAN0pJqMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./src/lib/ablyft/index.ts
var ablyft = __webpack_require__(49423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(71843);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FiberManualRecord.js
var FiberManualRecord = __webpack_require__(93837);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/CardsSlider.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 33px;\n  padding: ",
        ";\n  font-size: 10px;\n  border: none;\n  cursor: pointer;\n  white-space: nowrap;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 26.88px;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  line-height: 17px;\n  letter-spacing: 0.4px;\n  margin: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 47px;\n  padding: ",
        ";\n  width: fill-available;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        "px;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f0f0f0;\n  border-radius: 33px;\n  padding: ",
        "px;\n  white-space: nowrap;\n  font-size: 8px;\n  letter-spacing: 0.4px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11px;\n  &:hover {\n    fill: #3c4340;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block !important;\n  margin: auto;\n  width: 293px !important;\n  height: 472px !important;\n  padding: ",
        "px;\n  gap: 32px;\n  border-radius: 20px;\n  background: #ffffff;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px !important;\n  height: 32px !important;\n  width: 32px !important;\n  color: #e3e4e4 !important;\n  &:hover {\n    color: #3c4340 !important;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px !important;\n  transform: translateY(-50%) rotate(180deg) !important;\n  height: 32px !important;\n  width: 32px !important;\n  color: #3c4340 !important;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}











function CardsSlider(param) {
    var _cards = param.cards, cards = _cards === void 0 ? [] : _cards;
    var ref = (0,react.useState)(null), sliderRef = ref[0], setSliderRef = ref[1];
    var ref1 = (0,react.useState)(0), currentTab = ref1[0], setCurrentTab = ref1[1];
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: function(oldIndex, newIndex) {
            return setCurrentTab(newIndex);
        },
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackIcon, {}),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextIcon, {}),
        arrows: !mobile,
        appendDots: function(dots) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    bottom: "-40px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    style: {
                        margin: "0px",
                        padding: 0
                    },
                    children: [
                        " ",
                        dots,
                        " "
                    ]
                })
            });
        },
        customPaging: function(i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "custom-dot ".concat(currentTab === i ? "active" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorIcon, {
                    style: {
                        fill: currentTab === i ? "#3C4340" : "#E3E4E4"
                    }
                })
            });
        }
    };
    var handleTabClick = function(index) {
        sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.slickGoTo(index);
        setCurrentTab(index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipsWrapper, {
                justifyContent: "center",
                children: cards.map(function(card, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectorChip, {
                        style: {
                            background: currentTab === index ? "#686D6B" : "#E3E4E4",
                            color: currentTab === index ? "#FFFFFF" : "#3C4340"
                        },
                        className: "tab ".concat(currentTab === index ? "active" : ""),
                        onClick: function() {
                            return handleTabClick(index);
                        },
                        children: card.title
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: function(slider) {
                        return setSliderRef(slider);
                    }
                }, settings), {
                    children: cards.map(function(card, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                priority: true,
                                                src: card.image,
                                                height: 176,
                                                width: 261,
                                                quality: 100,
                                                alt: card.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                                children: card.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                                children: card.content
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipsWrapper, {
                                                children: card.chips.map(function(chip, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip, {
                                                        children: chip
                                                    }, "chip-".concat(index));
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                            onClick: function() {
                                                return card.cta.onClick(card.cta.link);
                                            },
                                            variant: card.cta.variant,
                                            children: card.cta.title
                                        })
                                    })
                                ]
                            })
                        }, index);
                    })
                }))
            })
        ]
    });
}
var SelectorChip = styled_components_browser_esm/* default.button */.ZP.button(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(0.5, 2);
});
var Title = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(4);
});
var Subtitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(2, 0);
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(esm/* Button */.zx)(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(1, 3);
});
var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
var ChipsWrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var Chip = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.spacing(0.5);
});
var IndicatorIcon = (0,styled_components_browser_esm/* default */.ZP)(FiberManualRecord/* default */.Z)(_templateObject7());
var Card = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var BackIcon = (0,styled_components_browser_esm/* default */.ZP)(ArrowBackIos/* default */.Z)(_templateObject9());
var NextIcon = (0,styled_components_browser_esm/* default */.ZP)(ArrowBackIos/* default */.Z)(_templateObject10());
var SliderWrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject11(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 3);
});

;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/RegularNeedsCarousel.tsx

function RegularNeedsCarousel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 33.6px;\n  text-align: center;\n  ",
        " {\n    font-size: 32px;\n    text-align: center;\n    line-height: 48px;\n  }\n"
    ]);
    RegularNeedsCarousel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RegularNeedsCarousel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f8f8f8;\n  width: 343px;\n  padding: 24px;\n  padding-bottom: 54px;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  .slick-arrow {\n    color: #3c4340;\n  }\n  margin: auto;\n  ",
        " {\n    width: 540px;\n  }\n"
    ]);
    RegularNeedsCarousel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









function RegularNeedsCarousel() {
    var t = (0,useTranslation/* useTranslation */.$)("homepage").t;
    var openCalendlyLink = function(link) {
        ablyft/* ABLyft.trackCustomEvent */.XC.trackCustomEvent(ablyft/* CUSTOM_ABLYFT_EVENT.calendlyEngagement */.bn.calendlyEngagement);
        window.open(link, "_blank");
    };
    var cards = [
        {
            title: t("regularNeeds.card1.title"),
            content: t("regularNeeds.card1.content"),
            image: kantine,
            chips: [
                t("regularNeeds.card1.chips.1"),
                t("regularNeeds.card1.chips.2")
            ],
            cta: {
                title: t("regularNeeds.card1.cta"),
                variant: "secondary",
                onClick: openCalendlyLink,
                link: "https://calendly.com/food-program/beratungsgesprach-heykantine"
            }
        },
        {
            title: t("regularNeeds.card2.title"),
            content: t("regularNeeds.card2.content"),
            image: inhouse,
            chips: [
                t("regularNeeds.card2.chips.1"),
                t("regularNeeds.card2.chips.2")
            ],
            cta: {
                title: t("regularNeeds.card2.cta"),
                variant: "secondary",
                onClick: openCalendlyLink,
                link: "https://calendly.com/fee-heycater-meetme/15min"
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularNeedsCarousel_Title, {
                children: t("products.regularNeeds")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSlider, {
                cards: cards
            })
        ]
    });
}
var RegularNeedsCarousel_Title = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(RegularNeedsCarousel_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(RegularNeedsCarousel_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/eventmanagement.png
/* harmony default export */ var eventmanagement = ({"src":"/_next/static/media/eventmanagement.a6cfb22d.png","height":831,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAbFBMVEWleGZMRkKTWVC2oZKIRz6FhoKik41oQjmrrqu+trLCpZ6xhXvDs6uhpqaGgHyUb2OmlpGVl5diXU3AyMaQVzqFdHTBJi14NSiDh4dHQDaUnaFXRD3d5+i0sLGSenfFoZSopJufbF3R09O6TEWT33kKAAAAHHRSTlP9U/39tL7+wLn+/Pr9ubuztbfF/P14/Pp6enj99shgcAAAAAlwSFlzAAALEwAACxMBAJqcGAAAADxJREFUeJwFwQUSgCAAAMFDSWMwsAnj/390l0lZ249KcM8xOvfuJLpaB32SWsK1VQu5KTzrd2D84KU04gdPQALtAlMILQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/individualoffer.png
/* harmony default export */ var individualoffer = ({"src":"/_next/static/media/individualoffer.5e04340e.png","height":554,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAclBMVEWmg1WBUS2YiHDHlHC8tZWhqouwuKOBjmTZ263Hwafeu5Lm8sjdp2qKbEtTWiNFXBrp7tPMoozDrHqFj4W/jTCmey+bjn58YD+Tn4erb0ipkm3z/trUg0a/vYSZqHRyYyy706bz4MbFh0vg4rTzvGrh0b4Eh18/AAAAG3RSTlO3s7H8t3h6vP76+v39yPy4/f29UrH8xrlV/PoyXHEnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPklEQVR4nGPg5WdnYRAXk2CQ51NQlJFUZWOQ4+QWEJSSZmWQ5uLhkObkYGWQZZZRUhZVYWNgZ2JkYBEREgYAW44DOVCh4pgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/privatemarketplace.png
/* harmony default export */ var privatemarketplace = ({"src":"/_next/static/media/privatemarketplace.5f7399cc.png","height":554,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAY1BMVEWjj36pg1Ty8N58flisnZLLqZO2qZTSwLV6elHXxaLX2LedgXBjXULhxLjk2ri8rZW4noDZv6ZoWTGmnmqYiU/KuKd+Wy+mjVqQd0mtmXnr4c/YsJHp1LrqyqLx7a7CqICZlnCKgqtAAAAAGXRSTlO4tP65t/68/Xn8+sVV/P39/fxTv3r6tf3AbUNPDAAAAAlwSFlzAAALEwAACxMBAJqcGAAAADtJREFUeJwFwQcCgCAMALEDgRb3VsD1/1ea0LgKXGgpXRLvLyXJKDFm5duOoa+tUuyb7+lZOcOOMcv8Az7PApgo7chnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/SpecificNeedsCarousel.tsx

function SpecificNeedsCarousel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 33.6px;\n  text-align: left;\n  ",
        " {\n    font-size: 32px;\n    text-align: center;\n    line-height: 48px;\n  }\n"
    ]);
    SpecificNeedsCarousel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SpecificNeedsCarousel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f8f8f8;\n  width: 343px;\n  padding: ",
        "px;\n  padding-bottom: 54px;\n  border-radius: ",
        "px;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  .slick-arrow {\n    color: #3c4340;\n  }\n  margin: auto;\n  ",
        " {\n    width: 540px;\n  }\n"
    ]);
    SpecificNeedsCarousel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











function SpecificNeedsCarousel() {
    var t = (0,useTranslation/* useTranslation */.$)("homepage").t;
    var router = (0,next_router.useRouter)();
    var openCalendlyLink = function(link) {
        ablyft/* ABLyft.trackCustomEvent */.XC.trackCustomEvent(ablyft/* CUSTOM_ABLYFT_EVENT.calendlyEngagement */.bn.calendlyEngagement);
        window.open(link, "_blank");
    };
    var scrollToQF = function(link) {
        router.push(link);
    };
    var cards = [
        {
            title: t("specificNeeds.card1.title"),
            content: t("specificNeeds.card1.content"),
            image: individualoffer,
            chips: [
                t("specificNeeds.card1.chips.1"),
                t("specificNeeds.card1.chips.2"), 
            ],
            cta: {
                title: t("specificNeeds.card1.cta"),
                variant: "primary",
                onClick: scrollToQF,
                link: "#qf-start"
            }
        },
        {
            title: t("specificNeeds.card2.title"),
            content: t("specificNeeds.card2.content"),
            image: eventmanagement,
            chips: [
                t("specificNeeds.card2.chips.1"),
                t("specificNeeds.card2.chips.2"), 
            ],
            cta: {
                title: t("specificNeeds.card2.cta"),
                variant: "secondary",
                onClick: openCalendlyLink,
                link: "https://calendly.com/anna-marie-stiddig/30min"
            }
        },
        {
            title: t("specificNeeds.card3.title"),
            content: t("specificNeeds.card3.content"),
            image: privatemarketplace,
            chips: [
                t("specificNeeds.card3.chips.1"),
                t("specificNeeds.card3.chips.2"), 
            ],
            cta: {
                title: t("specificNeeds.card3.cta"),
                variant: "secondary",
                onClick: openCalendlyLink,
                link: "https://calendly.com/fee-heycater-meetme/15min"
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecificNeedsCarousel_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecificNeedsCarousel_Title, {
                children: t("products.specificNeeds")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSlider, {
                cards: cards
            })
        ]
    });
}
var SpecificNeedsCarousel_Title = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(SpecificNeedsCarousel_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var SpecificNeedsCarousel_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(SpecificNeedsCarousel_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});

;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/CardSelections.tsx

function CardSelections_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  gap: ",
        "px;\n\n  ",
        " {\n    width: 1118px;\n    flex-direction: row;\n    padding: ",
        ";\n  }\n"
    ]);
    CardSelections_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function CardSelections() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardSelections_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecificNeedsCarousel, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularNeedsCarousel, {})
        ]
    });
}
var CardSelections_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(CardSelections_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2);
});


/***/ })

}]);